import React from "react";
import Slider from "react-slick";
import { videoData } from "./videoData";
import { useNavigate } from "react-router-dom";

const VideoSection = () => {
  const navigate = useNavigate();

  const styles = {
    componentContainer: {
      background: "linear-gradient(to bottom, #ffffff, #fcfdfe)",
      padding: "60px 0px",
    },
    maincard: {
      border: "1px solid rgba(0, 0, 0, 0.04)",
      padding: "16px",
      backgroundColor: "#ffffff",
      borderRadius: "20px",
      margin: "15px",
      boxShadow: "0 10px 30px rgba(0, 0, 0, 0.05)",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      cursor: "pointer",
    },

    section: {
      margin: "20px 0",
      padding: "0 250px",
    },
    sectionTitle: {
      fontSize: "2rem",
      fontWeight: "800",
      marginBottom: "30px",
      marginLeft: "15px",
      color: "#1a1a1a",
      letterSpacing: "-0.5px",
    },
    thumbnail: {
      width: "100%",
      height: "200px",
      borderRadius: "8px",
      cursor: "pointer",
      padding: "0px 0px",
    },
    videoDetails: {
      padding: "20px 0px 0px 0px",
      color: "#333333",
    },
    videoTitle: {
      fontSize: "1.1rem",
      fontWeight: "700",
      marginBottom: "8px",
      color: "#111111",
    },
  };

  const sliderSettings = {
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1040,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const handleCardClick = (video, sectionTitle) => {
    navigate("/video", { state: { video, sectionTitle } });
  };

  return (
    <div>
      <style>
        {`
          .video-card-hover:hover {
            transform: translateY(-8px);
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1) !important;
            border-color: rgba(255, 0, 0, 0.1) !important;
          }
          .video-card-hover:hover .thumbnail-hover {
            transform: scale(1.02);
          }
          .thumbnail-hover {
            transition: transform 0.5s ease;
          }
        `}
      </style>
      <div style={styles.componentContainer}>
        {Object.entries(videoData).map(([sectionTitle, videos]) =>
          sectionTitle === "Banner" ? null : (
            <div className="section" key={sectionTitle} style={styles.section}>
              <h2 style={styles.sectionTitle}>{sectionTitle}</h2>
              <Slider {...sliderSettings}>
                {videos.map((video) => (
                  <div
                    key={video.id}
                    onClick={() => handleCardClick(video, sectionTitle)}
                  >
                    <div style={styles.maincard} className="video-card-hover">
                      <img
                        src={video.thumbnail}
                        alt={video.title}
                        style={styles.thumbnail}
                        className="thumbnail thumbnail-hover"
                      />
                      <div style={styles.videoDetails}>
                        <div style={styles.videoTitle}>{video.title}</div>
                        <div className="video-content">{video.subtitle}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default VideoSection;
